import template from './dashboard-card-requested-devices.component.html';
import controller from './dashboard-card-requested-devices.controller';

const dashboardCardRequestedDevices = {
  template,
  controller,
};

export default dashboardCardRequestedDevices;
